import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { useLanguage } from "../../hooks/use-language.js";

export function Footer() {
  const intl = useIntl();
  const { language } = useLanguage();
  const base = `/${language}`;

  return (
    <footer className="mt-auto border-t border-border bg-background">
      <nav
        className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-4 px-4 py-4 text-sm text-muted-fg"
        aria-label={intl.formatMessage({ id: "footer.nav_aria_label" })}
      >
        <span>© {new Date().getFullYear()} unpii.me</span>
        <ul className="flex gap-4">
          <li>
            <Link
              to={`${base}/legal/imprint`}
              className="rounded hover:text-foreground focus-visible:outline-2 focus-visible:outline-ring"
            >
              {intl.formatMessage({ id: "footer.imprint" })}
            </Link>
          </li>
          <li>
            <Link
              to={`${base}/legal/privacy`}
              className="rounded hover:text-foreground focus-visible:outline-2 focus-visible:outline-ring"
            >
              {intl.formatMessage({ id: "footer.privacy" })}
            </Link>
          </li>
          <li>
            <Link
              to={`${base}/legal/terms`}
              className="rounded hover:text-foreground focus-visible:outline-2 focus-visible:outline-ring"
            >
              {intl.formatMessage({ id: "footer.terms" })}
            </Link>
          </li>
          <li>
            <Link
              to={`${base}/legal/avv`}
              className="rounded hover:text-foreground focus-visible:outline-2 focus-visible:outline-ring"
            >
              {intl.formatMessage({ id: "footer.avv" })}
            </Link>
          </li>
          <li>
            <Link
              to={`${base}/cancel`}
              className="rounded hover:text-foreground focus-visible:outline-2 focus-visible:outline-ring"
            >
              {intl.formatMessage({ id: "footer.cancel" })}
            </Link>
          </li>
        </ul>
      </nav>
    </footer>
  );
}
